<div class="confirmation-box dialog-container-custom">
    <div class="dialog-header">
        <h2 class="dialog-header-title">{{ title | translate }}</h2>
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/close-dialog-icon.svg'"
            (afterClick)="onCancel()"
        />
    </div>

    <mat-dialog-content class="dialog-content">
        <img src="assets/images/warning_snackbar_icon.svg" alt="" />
        <p class="confirmation-message">{{ message | translate }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        @if (cancelButtonLabel) {
            <lokos-button
                [label]="cancelButtonLabel"
                [disabled]="false"
                (afterClick)="onCancel()"
            />
        }
        @if (confirmationButtonLabel) {
            <lokos-button
                [label]="confirmationButtonLabel"
                [type]="'primary'"
                [disabled]="false"
                (afterClick)="onConfirm()"
            />
        }
    </mat-dialog-actions>
</div>
